import React, { useState } from 'react';
import { Grid, Typography, Avatar, Box, Button } from '@mui/material';

const LogosOptions = ({ formData, handleNestedChange, tempTheme }) => {
  const [images, setImages] = useState({});

  const handleImageUpload = (event) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImages((prevImages) => ({
          ...prevImages,
          [name]: e.target.result,
        }));
        handleNestedChange('logos', name, e.target.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const renderAvatarButton = (name, position) => (
    <Box
      display="flex"
      justifyContent="center"
      mb={2}
      sx={{ paddingTop: position === 'below' ? 2 : 0 }}
    >
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id={`upload-${name}`}
        type="file"
        name={name}
        onChange={handleImageUpload}
      />
      <label htmlFor={`upload-${name}`}>
        <Button
          component="span"
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: `url(${images[name] || ''})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: images[name] ? 'transparent' : 'inherit',
            border: '1px solid #ccc',
            ...tempTheme,
          }}
        >
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </Button>
      </label>
    </Box>
  );

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Logos
      </Typography>
      <Grid
        container
        spacing={3}
      >
        {['small', 'medium', 'large'].map((size) => (
          <Grid
            item
            xs={12}
            sm={4}
            key={size}
          >
            {renderAvatarButton(size, 'above')}
          </Grid>
        ))}
        {['lightSmall', 'lightMedium', 'lightLarge'].map((size) => (
          <Grid
            item
            xs={12}
            sm={4}
            key={size}
          >
            {renderAvatarButton(size, 'below')}
          </Grid>
        ))}
        <Grid
          item
          xs={12}
        >
          {renderAvatarButton('favicon', 'above')}
        </Grid>
      </Grid>
    </>
  );
};

export default LogosOptions;
